import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Grid, Typography, Input, Button, duration } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Skeleton from '@material-ui/lab/Skeleton';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Box from '@material-ui/core/Box';
import Rating from '@material-ui/lab/Rating';
import { red } from '@material-ui/core/colors';

import ReactPlayer from 'react-player/lazy'
import YouTube from 'react-youtube';
import { ethers } from "ethers";
import Web3 from 'web3';
import { Logger } from 'ethers/lib/utils';

require('dotenv').config()

let web3
web3 = new Web3(Web3.givenProvider);

let userAccount;
web3.eth.getAccounts((error, accounts) => {
    console.log(accounts);
    userAccount = accounts[0]
    console.log(userAccount)
});
//let provider = new ethers.getDefaultProvider('ropsten')
const provider = new ethers.providers.Web3Provider(window.ethereum);

// There is only ever up to one account in MetaMask exposed
//const signer = provider.getSigner();
//console.log(signer)

const RCT_ADDRESS = '0x9fdf34Ae804bA0aB98A410FDF5dc85FF02A0e437';
const RCT_ABI = [
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "_owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "_spender",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "_value",
				"type": "uint256"
			}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "approve",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "subtractedValue",
				"type": "uint256"
			}
		],
		"name": "decreaseAllowance",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "addedValue",
				"type": "uint256"
			}
		],
		"name": "increaseAllowance",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "_amount",
				"type": "uint256"
			}
		],
		"name": "sendTokensToPartner",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_streamOwner",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "_amount",
				"type": "uint256"
			}
		],
		"name": "sendTokensToStreamer",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "transfer",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "_from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "_to",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "_value",
				"type": "uint256"
			}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "transferFrom",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "addressBalanceTracker",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			}
		],
		"name": "allowance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "allowanceTracker",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "balanceOf",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "decimals",
		"outputs": [
			{
				"internalType": "uint8",
				"name": "",
				"type": "uint8"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "standard",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];

const key = '0x34F25DD9CCBA9EF55E296BD0139C7CA75CDC8AA3E9DC8758D082C204AB5BC3A6';//process.env["REACT_APP_PRIVATE_KEY"];//
const wallet = new ethers.Wallet(key, provider);
const contract = new ethers.Contract(RCT_ADDRESS, RCT_ABI, wallet)
var decimalPlaces = 18;
let amount// = ethers.utils.parseUnits('0.666', decimalPlaces);


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,        
	},
	videoTile: {

	},
    paper: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: '#fd5d93',//theme.palette.text.secondary,
        backgroundColor: '#6c757d',
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
      },
      expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
      expandOpen: {
        transform: 'rotate(180deg)',
      },
      avatar: {
        backgroundColor: red[800],
      },
}));


const YouTubeContainer = () => {
    const classes = useStyles();

    const [searchResults, setSearchResults] = useState([])
    const [query, setQuery] = useState('')

    var search = require('youtube-search');
 
    var youTubeSearchOpts = {
        maxResults: 9,
        key: 'AIzaSyD5pU1jBxVnK9yAlrL1k-I9cJVZIlkM-aE' // process.env['REACT_APP_YOUTUBE_API_KEY']
    };
    
    const searchVideos = (query) => {
        console.log(query)
        search (query, youTubeSearchOpts, function(err, results) {
            if(err) {
                return console.error(err);
            }   
            setSearchResults(results)
        });
    }
    
    const onQueryChange = (event) => {
        console.log(event.target.value)
        setQuery(event.target.value)
    }

    const opts = {
        height: '200',
        width: '250',
        playerVars: { //https://developers.google.com/youtube/player_parameters
            autoplay: 1,
            controls: 1,
            enablejsapi: 1,
        },
    };

    const payTheMan = (amount) => {
        let sendPromise = contract.sendTokensToStreamer(userAccount, ethers.utils.parseUnits(amount.toFixed(18), decimalPlaces));			   
        sendPromise.then((tx) => {
            console.log(tx)
        });
        console.log(`Payout executed!`)
    }

    const _onReady = (event) => {
        // access to player in all event handlers via event.target
        console.log(`video is loaded, ready and paused.`)
        //event.target.seekTo(100);
        event.target.pauseVideo();
    }

    const _onEnded = (event) => {
        console.log(`video has ended and you get paid!`);
        // get video duration

        // duration * .0035

        payTheMan(2.33)
    }

    const _onPause = (event) => {

    }

    const _onError = (event) => {
        console.error(event)
    }

    let duration
    let time
    const _onStateChange = (event) => {
        //console.info(`state info: ${event}`)
        //console.info(`state changed...${event.data}`)
        // need to start the current video over
        let playerStatus = event.data;
        if (playerStatus == -1) {
            // unstarted
            //console.log('Video is unstarted.')
            event.target.addEventListener('buffering', (e) => {
                console.log('seeked')
            })
        } else if (playerStatus == 0) {
            // ended-completed video, payment due
            //console.log('video has ended')
        } else if (playerStatus == 3) {
            // buffering
            //console.log('video is buffering')
            // this could mean they fast forward
            // todo: restart the player..
            duration = event.target.getDuration();
            time = event.target.getCurrentTime();
            console.info(`Duration: ${duration} || Time: ${time}`)
            event.target.seekTo(0)
            //console.log(event)
        }
    }

    // load some videos on page load
    //searchVideos('crypto')


    return (
        <div>
            <div>
                <Typography color='secondary'>
                    Search YouTube and Earn! You will earn 2.33 RCT for each video watched until the end.
                </Typography>
            </div>
            <div>
                <input 
                    type='text'
                    value={query}
                    onChange={onQueryChange}    
                />
                <button
                    onClick={() => { searchVideos(query) }}
                >Search
                </button>
                <div style={{ color: 'white' }}>
                <Grid container spacing={1}>
                    {searchResults.map(({id, link, kind, publishedAt, channelId, channelTitle, title, description, thumbnails}, idx) => {
                        return (
                            <Grid item xs={12} md={4} lg={4}>   
								{title}                        
                               <YouTube key={idx}
                                    videoId={id}
                                    opts={opts}
                                    id={id}
                                    onReady={_onReady}
                                    onEnd={_onEnded}
                                    onStateChange={_onStateChange}
                                />
                            </Grid>
                        );
                    })}
                   </Grid>
                </div>
            </div>
           
            {/* using react-player */}
            {/* <ReactPlayer url='https://www.youtube.com/watch?v=ysz5S6PUM-U' /> */}
        </div>
    )
}

export default YouTubeContainer;